import { makeActionCreator } from '../../config/store/utils'
import { batch } from 'react-redux'
import { getKeplerHardBraking, getKeplerUrl } from '../../services/keplerServices'

export const GET_MAPBOX_FRENADOS = 'GET_MAPBOX_FRENADOS'
export const GET_MAPBOX_FRENADOS_ERROR = 'GET_MAPBOX_FRENADOS_ERROR'
export const GET_MAPBOX_FRENADOS_SUCCESS = 'GET_MAPBOX_FRENADOS_SUCCESS'
export const onGetMapbox = makeActionCreator(GET_MAPBOX_FRENADOS)
export const onGetMapboxError = makeActionCreator(GET_MAPBOX_FRENADOS_ERROR, 'payload')
export const onGetMapboxSuccess = makeActionCreator(GET_MAPBOX_FRENADOS_SUCCESS, 'payload')
export const onGetMapboxFrenadosThunk = date => async (dispatch, getState) => {
  dispatch(onGetMapbox())

  try {
    const {
      apis: {
        base: { apiKey, apiName }
      }
    } = getState().auth
    var functionData = { apiKey, apiName }

    const { url } = await getKeplerHardBraking(functionData)
    console.log(url.urls[0])
    if (url.message === 'No data available for this day.') {
      const urlData = []
      return batch(() => {
        dispatch(onGetMapboxSuccess({ urlData }))
      })
    }
    const { data: urlData } = await getKeplerUrl({
      apiKey,
      apiName,
      url: url.urls[0]
    })

    return batch(() => {
      dispatch(onGetMapboxSuccess({ urlData }))
    })
  } catch (error) {
    return dispatch(onGetMapboxError({ error }))
  }
}
